import React from 'react';

// this is a replacement for the anonymous function in the user helper
const AnonymousUserDisplay = ({ anonUser, showArticle = false, articleCaps = false }) => {
  if (anonUser.username) {
    return <strong>{anonUser.username}</strong>;
  }
  let title = 'SumZero Member';

  if (anonUser.isAllocator) {
    title = 'SumZero Allocator Member';
  } else if (anonUser.title && anonUser.title !== 'Other') {
    title = anonUser.title;
  } else if (
    anonUser.mostRecentEmployer &&
    anonUser.mostRecentEmployer.title &&
    anonUser.mostRecentEmployer.title !== 'Other'
  ) {
    title = anonUser.mostRecentEmployer.title;
  }
  // TODO: Add former member flag

  const firstChar = articleCaps ? 'A' : 'a';
  const article = /^[aeiou]/i.test(title) ? `${firstChar}n ` : `${firstChar} `;

  return (
    <>
      {showArticle && article}
      {title}
    </>
  );
};

export default AnonymousUserDisplay;
